module.exports = __webpack_public_path__ + "img/nature-1.24a217a1.jpg";